import * as React from 'react';
import { Button, Icon, Input, Modal } from '../..';

type ModalProps = {
  onCloseModal: () => void;
};

function ReturnItem({ onCloseModal }: ModalProps) {
  const [saleNumber, setSaleNumber] = React.useState('');

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-md bg-white min-w-[700px] overflow-hidden">
        <form>
          <div className="flex flex-col p-5">
            <h3
              className="text-pos-black text-[20px] font-semibold mb-2
              inline-flex whitespace-pre"
            >
              Return Items
            </h3>
            <div className="mt-2 mb-2 flex flex-row items-end justify-between space-x-4">
              <div className="w-full">
                <label htmlFor="saleNumber" className="text-xbase block mb-1">
                  Sale Number
                </label>
                <Input
                  name="saleNumber"
                  id="saleNumber"
                  value={saleNumber}
                  placeholder="Enter sale number"
                  onChange={event => setSaleNumber(event.target.value)}
                />
              </div>
              <Button
                label="Find"
                onClick={() => false}
                type="button"
                className="bg-[#f6f8fa] min-w-[120px] h-[42px] !text-pos-black text-xbase border border-[rgba(27,31,36,0.15)] 
                shadow-[0_1px_0_rgba(27,31,36,0.04),inset_0_1px_0_rgba(255,255,255,0.25)] font-medium"
              />
            </div>

            <div className="mt-5 mb-2 overflow-x-auto overflow-y-auto relative max-h-[500px] min-h-[200px]">
              <table className="table-auto border-collapse w-full whitespace-no-wrap bg-white table-striped">
                <thead>
                  <tr className="text-left bg-pos-header-bg sticky top-0 z-10">
                    <th className="!text-xbase font-medium w-[1%]">#</th>
                    <th className="!text-xbase font-medium">Product</th>
                    <th className="!text-xbase font-medium w-[20%]">Total</th>
                    <th className="!text-xbase font-medium w-[20%]">Action</th>
                  </tr>
                </thead>
                <tbody className="relative">
                  {/* <tr className="flex absolute inset-0 bg-[#f2f2f2] bg-opacity-75 transition-opacity text-pos-black">
                    <td
                      colSpan={8}
                      rowSpan={7}
                      className="!border-none w-full h-full"
                    >
                      <div className="fixed left-[50%] translate-x-[-50%] top-[60%] flex flex-col items-center justify-center p-4 font-medium">
                        <Icon id="loader" className="w-[40px] h-[40px]" />
                        <span className="text-pos-black">Loading sale...</span>
                      </div>
                    </td>
                  </tr> */}
                  {/* <tr className="flex absolute inset-0 bg-[#f2f2f2] bg-opacity-75 transition-opacity">
                    <td
                      colSpan={8}
                      rowSpan={7}
                      className="!border-none w-full h-full"
                    >
                      <div className="fixed left-[50%] translate-x-[-50%] top-[60%] flex flex-col items-center justify-center p-4 font-medium">
                        <span className="text-pos-black test-sm">
                          No sale with No.{' '}
                          <span className="text-pos-deep-orange">5677888</span>{' '}
                          found!
                        </span>
                      </div>
                    </td>
                  </tr> */}
                  {new Array(5).fill(null).map(() => (
                    <tr>
                      <td className="!text-sm w-[1%]">1</td>
                      <td className="!text-sm">Nestle Milo</td>
                      <td className="!text-sm">100.00</td>
                      <td className="!text-sm">
                        <div>
                          <button
                            type="button"
                            onClick={() => false}
                            className="bg-pos-green border border-[rgba(27,31,36,0.15)] 
                          inline-flex py-2 px-3 text-white text-[13px] leading-none rounded-md cursor-pointer"
                          >
                            Refund
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={2}>Total</td>
                    <td>653.64</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default ReturnItem;
